import React from "react";
// import AkashSir from "../../images/akash_sir.jpeg";
// import RanjitSir from "../../images/trainers/Ranjeet_Sir.jpg";
import SidharthSir from "../../images/trainers/sidharthSir.jpeg";
import AshuSir from "../../images/trainers/AshuSirImg.png";
import Kanhaiya from "../../images/trainers/Kanhaiya.jpg";
// import rajendrajangid from "../../images/trainers/rajendrajangid.png";
import ayush from "../../images/trainers/ayush.jpeg";
// import govind from "../../images/trainers/govind.jpeg";
import govind1 from "../../images/trainers/govind1.jpeg";

// import dheeraj from "../../images/trainers/dheeraj_sir.jpeg";
import divya from "../../images/trainers/divya.jpeg";
// import monkey from "../../images/trainers/monkey.jpg";



const OurTrainer = () => {
  return (
    <>
      <section className="ExpertTrainSec">
        <div className="container">
          <div className="row">
            <div className="col-12">
              <h2 class="YellowHeading">Our Expert Team</h2>
            </div>
          </div>
          <div className="row gy-5">
            <div className="col-lg-6 col-12">
              <div className="TeamDiv">
                <div className="Fir">
                  <div className="imgDiv">
                    <img src={AshuSir} alt="teacher img" />
                  </div>
                </div>
                <div className="Sec">
                  <h3>Ashutoshh Singh</h3>
                  <h6>CTO & Corporate Trainer</h6>
                  <div>
                    <p>
                      Ashutoshh's innovative vision, technical expertise, and
                      unwavering dedication have played a pivotal role in driving
                      the company's business development and growth. His ability
                      to navigate the ever-evolving tech landscape has not only
                      kept the company at the forefront but has also inspired the
                      entire team.
                    </p>
                    <span>
                      His commitment to knowledge-sharing and skill development
                      has empowered the team to excel. His training programs have
                      not only equipped individuals with essential skills but have
                      also contributed significantly to the overall professional
                      growth of the organization.
                    </span>
                  </div>
                </div>
              </div>
            </div>
            <div className="col-lg-6 col-12">
              <div className="TeamDiv">
                <div className="Fir">
                  <div className="imgDiv">
                    <img src={SidharthSir} alt="teacher img" />
                  </div>
                </div>
                <div className="Sec">
                  <h3>Siddharth Singh</h3>
                  <h6>
                    Founder & Director (Upflairs Pvt Ltd), Embedded Systems,
                    Robotics & IoT Expert
                  </h6>
                  <p>
                    Siddharth is having an experience of 10+ years in the field
                    of IoT , Embedded System & Robotics.Siddharth being the
                    company's director, not only manages the company well but is
                    also a wonderful Instructor. With years of industry
                    experience and a passion for innovation,he brings
                    unparalleled expertise to our courses and learning to the
                    students.
                  </p>
                  <p>
                    His Key expertise are - AVR MCUs, Peripherals
                    (ADC/Timer/Counter/Interrupts), Communication Protocols
                    (USART/SPI/I2C/USB/GSM/GPS/RFID), Sensors (Digital/Analog),
                    IDEs (Keil/AVR Studio/IAR), Simulation (Proteus),PCB
                    Designing (PCB express/Proteus), Raspberry Pi, Arduino
                  </p>
                </div>
              </div>
            </div>
            {/* <div className="col-lg-6 col-12">
              <div className="TeamDiv">
                <div className="Fir">
                  <div className="imgDiv">
                    <img src={dheeraj} alt="teacher img" />
                  </div>
                </div>
                <div className="Sec">
                  <h3>Dheeraj Madhukar</h3>
                  <h6>Application Security Engineer | Cyber Security Expert | Linux Server Engineer</h6>
                  <p>
                  Application Security Engineer | Cyber Security Expert | Linux Server Engineer
                  Dheeraj Madhukar is a highly experienced cybersecurity professional and corporate trainer with over 10+ years of industry experience. He is the Director at TechnoLegends and has delivered training at prestigious government organizations including CDAC (Ministry of Electronics & IT) and the Indian Air Force. He specializes in securing applications and infrastructure through real-world practical implementation and advanced security practices.
                  </p>
                  <span>
                  His key expertise are :-
                  Web Application Penetration Testing, Network Security, Mobile & API Security, VAPT & Security Audits, Source Code Review (PHP, JavaScript, Android), Android Reverse Engineering, Digital Forensics (Windows & Android), Linux Server Administration, CI/CD Security, BASH Automation, Web Application Firewall (WAF), SELinux, iptables & Firewall Management, Audit Logs & AVC Reporting, RHCSA/RHCE, and Security Automation.
                  </span>
                </div>
              </div>
            </div> */}


            <div className="col-lg-6 col-12">
              <div className="TeamDiv">
                <div className="Fir">
                  <div className="imgDiv">
                    <img src={Kanhaiya} alt="teacher img" />
                  </div>
                </div>
                <div className="Sec">
                  <h3>Kanhaiya Lal Gurjar</h3>
                  <h6>DSA & Full Stack Instructor</h6>
                  <p>
                    Kanhaiya Lal Gurjar is a skilled Full Stack Developer and DSA Instructor with 2.5 years of professional experience in software development and technical training. He has hands-on experience in building scalable web applications and mentoring students in programming and problem-solving. With a strong foundation in core computer science concepts, he focuses on strengthening students’ understanding of Data Structures & Algorithms along with real-world development practices.
                  </p>
                  <span>
                  His key expertise are :-
                  Data Structures & Algorithms (DSA), C++, Java, JavaScript, Full Stack Web Development, MERN Stack, Backend Development, Frontend Development, REST APIs, Database Management (SQL & MongoDB), Git & GitHub, OOPs Concepts, Problem Solving, and Technical Training.
                  </span>
                </div>
              </div>
            </div>
           
            <div className="col-lg-6 col-12">
              <div className="TeamDiv">
                <div className="Fir">
                  <div className="imgDiv">
                    <img src={ayush} alt="teacher img" />
                  </div>
                </div>
                <div className="Sec">
                  <h3>Ayush Man</h3>
                  <h6>Devops Instructor</h6>
                  <p>
                  Ayush is having an experience of 2+ Years and is an expert at the forefront of cloud computing and DevOps methodologies, equipping our learners with the skills to navigate and optimize cloud environments efficiently. Our instructor not only possess in-depth knowledge of cloud platforms and DevOps practices but also have a passion for teaching. He guide our students in harnessing the power of cloud technologies, ensuring he is well-prepared to thrive in the fast-evolving world of IT and infrastructure management.
                  </p>
                  <span>
                  His Key expertise are - Linux , Cloud (like AWS, microsoft azure , GCP ), DevOps tools (like docker , kubernetes , jenkins , ansible , terraform ) , monitoring.
                  </span>
                </div>
              </div>
            </div>
            <div className="col-lg-6 col-12">
              <div className="TeamDiv">
                <div className="Fir">
                  <div className="imgDiv">
                    <img style={{ transform: "scale(1.3)" }} src={govind1} alt="teacher img" />
                  </div>
                </div>
                <div className="Sec">
                  <h3>Govind Kumawat</h3>
                  <h6>Data Science Instructor</h6>
                  <p>
                    Govind Kumawat is an accomplished Data Science professional
                    with over 3+ years of experience, specializing in data
                    analysis, machine learning, and statistical modeling. With a
                    deep understanding of industry trends and a passion for
                    teaching, he empowers students with the skills and knowledge
                    needed to thrive in the dynamic and rapidly evolving field
                    of data science.
                  </p>
                  <span>
                    Programming & Core Skills: Python, SQL, NoSQL Machine
                    Learning & AI: Artificial Intelligence, Machine Learning,
                    Deep Learning, Generative AI, Large Language Models (LLMs)
                    Specialized Domains: Natural Language Processing (NLP),
                    Computer Vision MLOps & Cloud: MLOps, Cloud Computing
                  </span>
                </div>
              </div>
            </div>
            <div className="col-lg-6 col-12">
              <div className="TeamDiv">
                <div className="Fir">
                  <div className="imgDiv">
                    <img src={divya} alt="teacher img" />
                  </div>
                </div>
                <div className="Sec">
                  <h3>Divya Modi</h3>
                  <h6>Python & Data Science Instructor</h6>
                  <p>
                  Divya Modi is an accomplished Python & Data Science Instructor with over 2 years of experience in Artificial Intelligence, Machine Learning, and advanced data technologies. She is passionate about transforming complex concepts into practical learning experiences and has successfully mentored 1500+ students through workshops, masterclasses, and professional training programs. Her industry-oriented approach and hands-on teaching style make her a highly valued mentor in the AI and Data Science domain.
                  </p>
                  <span>
                  Her Key expertise are - Artificial Intelligence & Machine Learning, Deep Learning, Natural Language Processing (NLP), Data Analysis & Visualization: Pandas, NumPy, Matplotlib, Seaborn, EDA, Statistical Analysis, Databases: MySQL, MongoDB (NoSQL), Tools: Tableau, Excel, Web Scraping
                  </span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    </>
  );
};

export default OurTrainer;
